const state = {
  showLoading: false
};

const getters = {
  getShowLoading: state => state.showLoading
};

const mutations = {
  TOGGLE_LOADING: (state, payload) => (state.showLoading = payload)
};

const actions = {
  toggleLoading: ({ commit }, payload) => {
    commit("TOGGLE_LOADING", payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
